// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"3":"7977808d","77":"8c4dbcd1","94":"89a73ca5","157":"cb640cf0","218":"e82a1862","251":"0d576ee7","285":"c0072d9f","463":"18a86e44","486":"100f69ef","585":"ab3443be","617":"59e72b9c","645":"bf2fad3c","659":"1907c65e","927":"ac6acf4f","937":"e8be8203"}[chunkId] + ".js";
};